import React from 'react';

import { Button } from '@eluve/components';

import { useChat } from './ConversationContextProvider';

export const ConversationCheckInButton: React.FC = () => {
  const { toggleConnection, isConnected, appointmentConversationId } =
    useChat();

  return (
    <Button
      onClick={() => toggleConnection(!isConnected, appointmentConversationId)}
      fullWidth
    >
      {isConnected ? 'End Session' : 'Check In'}
    </Button>
  );
};
